import { supabase } from '@/lib/supabase';
import type { PageContent } from '@/types/db';

// Returns a flat { content_key: value } map for one page+language.
export async function getPageContent(pageSlug: string, language: string): Promise<Record<string, string>> {
  const { data, error } = await supabase
    .from('page_content')
    .select('content_key, value')
    .eq('page_slug', pageSlug)
    .eq('language', language);
  if (error) throw error;
  const map: Record<string, string> = {};
  for (const row of data ?? []) if (row.value != null) map[row.content_key] = row.value;
  return map;
}

export async function setPageContent(
  pageSlug: string,
  language: string,
  entries: Record<string, string>,
): Promise<void> {
  const rows = Object.entries(entries).map(([content_key, value]) => ({
    page_slug: pageSlug,
    language,
    content_key,
    value,
  }));
  if (rows.length === 0) return;
  const { error } = await supabase
    .from('page_content')
    .upsert(rows, { onConflict: 'page_slug,language,content_key' });
  if (error) throw error;
}

export async function getAllPageContent(): Promise<PageContent[]> {
  const { data, error } = await supabase.from('page_content').select('*');
  if (error) throw error;
  return data ?? [];
}
